import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-voucher-form',
  templateUrl: './voucher-form.component.html',
  styleUrls: ['./voucher-form.component.scss']
})
export class VoucherFormComponent {

  public data: any = {status: 2, show_at_frontend: 0};
  public sections:any = []
  @ViewChild('f') f : NgForm

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    this.initSection();
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    
    uuid.subscribe(val => {
      if(val) {
        this.init(val)
      }
    })
  }

  async initSection() {
    this.sections = await this.http.post("/admin/app/voucher/section/get");
  }

  async init(uuid) {
    this.data = await this.http.post('/admin/app/voucher/get', {voucher_uuid: uuid});
  }

  async submit() {

    await this.http.post("/admin/app/voucher/save", this.data);
    if (this.data.uuid) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'setting-voucher'])
      return;
    }
    await this.f.resetForm({status: 2});
  }

}
